import { Component, HostBinding, Inject, inject, Optional, RESPONSE_INIT, signal } from '@angular/core'
import { Response } from 'express';
import { HeaderAndFooterResponseInterface } from "@gea-waldviertler-website/gea-models";
import { NavigationStart, Router } from "@angular/router";
import { CustomerService } from "./services/customer.service";
import { MatomoService } from "./services/matomo.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { WagtailService } from "./services/wagtail.service";
import { RootclassService } from "./services/rootclass.service";
import { NotificationService } from "./services/notification.service";
import { CanonicalService } from "./services/canonical.service"
import { ServerErrorService } from "./services/server-error.service";
import { RESPONSE } from "../express.tokens";

@Component({
  selector: 'gea-shop-root',
  templateUrl: './app.component.html',
  standalone: false
})
export class AppComponent {
  rootClass = signal('someClass')
  @HostBinding('class') get class() { return this.rootClass() }
  title = 'gea-shop'
  cmsResponse = signal<HeaderAndFooterResponseInterface | undefined>(undefined)
  public customerService = inject(CustomerService)
  public matomoService = inject(MatomoService)
  private ngbModal = inject(NgbModal)
  private router = inject(Router)
  private cmsService = inject(WagtailService)
  private rcService = inject(RootclassService)
  public notificationService = inject(NotificationService)
  private canonicalService = inject(CanonicalService)
  public serverErrorService = inject(ServerErrorService)
  constructor(
    @Optional() @Inject(RESPONSE) private response?: Response,
    @Optional() @Inject(RESPONSE_INIT) private responseInit?: ResponseInit | null,
  ) {
    this.canonicalService.init()
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.ngbModal.dismissAll()
        this.serverErrorService.reset()
      }
    })
    this.rcService.getSubject().subscribe(cl => {
      this.rootClass.set('gea-root ' + cl)
    })
    this.cmsService.getHeaderAndFooter().subscribe({
      next: contents => {
        this.cmsResponse.set(contents)
      },
      error: (err) => {
        // API nicht erreichbar
          this.response?.status(500)
          if (this.responseInit) {
            this.responseInit.status = 500
          }
      },
    })
  }
}
